import { Backend, OrderByDirection } from '@freelancer/datastore/core';
import { toNumber } from '@freelancer/utils';
import { UserEmailRequestCollection } from './user-email-request.types';

const API_ENDPOINT = 'user/settings/email.php';

export function userEmailRequestBackend(): Backend<UserEmailRequestCollection> {
  return {
    defaultOrder: {
      field: 'id',
      direction: OrderByDirection.DESC,
    },
    fetch: () => ({
      endpoint: API_ENDPOINT,
      isGaf: true,
    }),
    push: undefined,
    set: undefined,
    update: undefined,
    remove: (_, id) => ({
      endpoint: API_ENDPOINT,
      isGaf: true,
      method: 'DELETE',
      payload: {
        email_request_id: toNumber(id),
      },
    }),
  };
}
